import { render, staticRenderFns } from "./FlatFrame.vue?vue&type=template&id=1b46b53a&scoped=true"
import script from "./FlatFrame.vue?vue&type=script&lang=js"
export * from "./FlatFrame.vue?vue&type=script&lang=js"
import style0 from "./FlatFrame.vue?vue&type=style&index=0&id=1b46b53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46b53a",
  null
  
)

export default component.exports